module.exports = __webpack_public_path__ + "img/diet.a1d2b4b0.svg";